'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _modal = require('./modal.scss');

var _modal2 = _interopRequireDefault(_modal);

var _modal3 = require('redux/modules/modal');

var modalActions = _interopRequireWildcard(_modal3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    dataModal: state.modal.data,
    openModal: state.modal.open
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, modalActions), dispatch);
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.modal = _react2.default.createRef();
    _this.closeModal = _this.closeModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, preStado) {
      if (this.props.openModal != prevProps.openModal && this.props.openModal) {
        this.modal.current.focus();
        document.getElementsByTagName("html")[0].classList.add("html--modalOpen");
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.props.setToogleShowModal(false);
      //damos foco al elemento que lanzo la modal
      document.getElementsByClassName("modalBtnPrev")[0].focus();
      document.getElementsByClassName("modalBtnPrev")[0].classList.remove("modalBtnPrev");
      document.getElementsByTagName("html")[0].classList.remove("html--modalOpen");
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dataModal = this.props.dataModal;
      var openModal = this.props.openModal;

      var modalClass = (0, _classnames2.default)({
        'modal': true,
        'modal--open': openModal
      });

      var modalText = dataModal.texts.map(function (element, index) {
        return _react2.default.createElement(
          'div',
          { key: element.text, className: 'modalTexts' },
          _react2.default.createElement(_components.ModalText, { text: element.text })
        );
      });

      return _react2.default.createElement(
        'div',
        { className: modalClass },
        _react2.default.createElement(
          'div',
          { className: 'modal__dialog', tabIndex: '-1', role: 'dialog', ref: this.modal },
          _react2.default.createElement(
            'div',
            { className: 'modal__content' },
            _react2.default.createElement(
              'p',
              { className: 'modal__content__title' },
              dataModal.title
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal__content__text' },
              modalText
            ),
            _react2.default.createElement(
              'button',
              { className: 'modal__content__btn', onClick: function onClick() {
                  return _this2.closeModal();
                } },
              'Volver ',
              _react2.default.createElement(
                'span',
                { className: 'modal__content__btn__text2' },
                'al mapa'
              )
            )
          )
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component), _class2.propTypes = {
  name: _propTypes2.default.string
}, _class2.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.jsx
// module id = 705
// module chunks = 0